import React from 'react';

const BlurredDataChip = ({ chipData }) => {
  return (
    <div className=" relative  flex items-center justify-center rounded-lg  border border-solid border-gray border-opacity-10 p-4 md:p-8  ">
      <div className="absolute z-10 h-full w-full   rounded-2xl bg-white bg-opacity-5 p-8 backdrop-blur-md"></div>
      <div className="z-20 flex flex-col gap-y-8 gap-x-8  md:flex-row md:gap-y-0">
        <div className="grid grid-cols-7 gap-x-6 md:grid-cols-5">
          {/* Chip 1 */}
          <div className="col-span-3 flex flex-col gap-y-1 md:col-span-2 md:gap-y-2">
            <p className="font-satoshi-medium text-[16px] text-gray-subtitle md:text-lg">
              {' '}
              {chipData?.chip1?.title}
            </p>
            <p className="font-satoshi-medium text-xl font-normal text-white md:text-2xl">
              {chipData?.chip1?.data}
            </p>
          </div>

          <div className="flex items-center justify-center">
            <hr className=" w-8  rotate-90  text-gray-subtitle" />
          </div>

          {/* Chip 2 */}
          <div className="col-span-3 flex flex-col gap-y-2 md:col-span-2">
            <p className="font-satoshi-medium text-[16px] text-gray-subtitle md:text-lg">
              {' '}
              {chipData?.chip2?.title}
            </p>
            <p className="font-satoshi-medium text-xl font-normal text-white md:text-2xl">
              {chipData?.chip2?.data}
            </p>
          </div>
        </div>

        <div className="flex hidden items-center justify-center md:flex">
          <hr className=" w-8  rotate-90  text-gray-subtitle" />
        </div>

        <div className="grid grid-cols-7 gap-x-6 md:grid-cols-5">
          {/* Chip 3 */}
          <div className="col-span-3 flex flex-col gap-y-2 md:col-span-2">
            <p className="font-satoshi-medium text-[16px] text-gray-subtitle md:text-lg">
              {' '}
              {chipData?.chip3?.title}
            </p>
            <p className="font-satoshi-medium text-xl font-normal text-white md:text-2xl">
              {chipData?.chip3?.data}
            </p>
          </div>

          <div className="flex items-center justify-center">
            <hr className=" w-8  rotate-90  text-gray-subtitle" />
          </div>

          {/* Chip 4 */}
          <div className="col-span-3 flex flex-col gap-y-2 md:col-span-2">
            <p className="font-satoshi-medium text-[16px] text-gray-subtitle md:text-lg">
              {' '}
              {chipData?.chip4?.title}
            </p>
            <p className="font-satoshi-medium text-xl font-normal text-white md:text-2xl">
              {chipData?.chip4?.data}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlurredDataChip;
